import Component from './component'

export default Component


// WEBPACK FOOTER //
// ./src/views/administrativo/home/container.js